import React from "react";

const CoreMaxCharacter = ({ text, editText = null, maxCharacter }) => {
  return (
    <div className="p-1">
      <small
        className={
          (text?.length || editText?.length) > maxCharacter
            ? "text-red-600"
            : "text-green-600"
        }
      >
        {text?.length || editText?.length || 0}
      </small>
      <small>/{maxCharacter}</small>
    </div>
  );
};

export default CoreMaxCharacter;
